import axios from 'axios';
import Storage from 'api/storage';
import { handleRequest, handleApiSucess, handleApiError } from './util.api';

export const URL_AUTH_LOGIN = '/auth/login';
export const URL_AUTH_RECOVER_PASSWORD = '/auth/recover_password';
export const URL_AUTH_RESET_PASSWORD = '/auth/reset_password';
export const URL_AUTH_VERIFY_TOKEN = '/auth/verify_token';
export const URL_AUTH_COMPLETE_INFO = '/auth/complete_info';
export const URL_AUTH_UPDATE_INFO = '/auth/update_info';

const service = {
  configure(endpoint, defaultHeaders) {
    this.endpoint = endpoint;
    this.defaultHeaders = defaultHeaders;

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
      headers: defaultHeaders,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  getToken() {
    return Storage.get('auth.token');
  },

  getUser() {
    return Storage.get('auth.user');
  },

  logout() {
    Storage.unset('auth.user');
    Storage.unset('auth.token');
  },

  login(email, password) {
    return this.axios
      .post(URL_AUTH_LOGIN, {
        email,
        password,
      })
      .then((result) => {
        Storage.set('auth.user', result.data.user);
        Storage.set('auth.token', result.data.token);
        return result;
      })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  recoverPassword(email) {
    return this.axios
      .post(URL_AUTH_RECOVER_PASSWORD, {
        email,
      })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  resetPassword(token, password) {
    return this.axios
      .post(URL_AUTH_RESET_PASSWORD, {
        token,
        password,
      })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  completeInfo(token, data) {
    return this.axios
      .put(URL_AUTH_COMPLETE_INFO, {
        token,
        ...data,
      })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  updateInfo(data) {
    return this.axios
      .put(URL_AUTH_UPDATE_INFO, { ...data }, { headers: { ...this.getAuthHeader() } })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  verifyToken() {
    return this.axios
      .get(URL_AUTH_VERIFY_TOKEN, {
        headers: this.getAuthHeader(),
      })
      .then((result) => {
        Storage.set('auth.user', result.data.user);
        return result;
      })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  isAuthenticated() {
    const token = this.getToken();
    return this.verifyToken(token);
  },

  getAuthHeader() {
    const token = this.getToken();
    return { 'X-Auth-Token': token };
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/auth.api.js